import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CPTransaction } from 'src/app/cp-payment-sheet/cp-payment-sheet.component';

@Component({
    selector: 'app-compare-cp-payments',
    templateUrl: './compare-cp-payments.component.html',
    styleUrls: ['./compare-cp-payments.component.scss'],
    standalone: false
})
export class CompareCpPaymentsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);


  @Input() selectedCustomerName: string;
  @Input() selectedCustomerId: number;
  @Input() selectedProfileId: number;
  @Input() transaction: CPTransaction;

  insertAmount: number;

  ngOnInit(): void {
  }


  reset() {
    this.activeModal.close();
  }
}
